<h2>Locais</h2>

<div class="tds-row">
  <app-button text="Criar local" (clicked)="create()"></app-button>
</div>

<app-table
  [headers]="headers"
  [content]="localsList"
  [showFilter]="true"
  [hasEdit]="true"
  [hasDelete]="true"
  (editing)="edit($event)"
  (deleting)="confirmDelete($event)"
>
</app-table>
